import type { CartItem, PriceSummary } from '@src/domains/cart/types/cart';

export const calculateItemTotalPriceSummary = (item: CartItem): PriceSummary => {
  const packageDiscountValue = item.costPreview.packageDiscountCents ?? 0;
  const total = item.costPreview.totalPriceCents - packageDiscountValue;

  return { total, discount: packageDiscountValue, previousPrice: item.costPreview.totalPriceCents };
};
